<template>
  <div v-if="!isReadonly" class="input-group input-group-short">
    <base-input
      v-model="localDuration"
      @change="changeDurationValue"
      name="training_duration"
      :isNumber="true"
    ></base-input>
    <div class="input-group-append">
      <base-dropdown-select
        :options="listOfDurationUnits"
        :title="title"
        v-model="localUnit"
        @input="changeDurationUnit"
        class="dropdown-append"
      ></base-dropdown-select>
    </div>
  </div>
  <span v-else-if="durationValueString">
    {{ durationValueString }}
  </span>
  <span v-else class="icon icon-infinity icon_inherit"></span>
</template>

<script>
import declension from '@/modules/declension.js'
import { unitDuration } from '@/main.config'

export default {
  name: 'DurationWithUnit',
  components: {
    BaseInput: () => import('@/base/BaseInput.vue'),
    BaseDropdownSelect: () => import('@/base/BaseDropdownSelect.vue')
  },
  model: {
    prop: 'durationValue'
  },
  props: {
    durationValue: {
      type: Number
    },
    durationUnit: {
      type: Number,
      required: false,
      default: 1
    },
    isReadonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function() {
    return {
      localDuration: null,
      localUnit: unitDuration.minutes,
      options: {
        [unitDuration.minutes]: {
          title: this.$tc('unit.minutes', 3)
        },
        [unitDuration.hours]: {
          title: this.$tc('unit.hours', 3)
        }
      }
    }
  },
  watch: {
    durationValue() {
      //Раньше здесь было обновление только если isReadonly, последить за этим компонентом
      this.localDuration = this.durationValue
    },
    durationUnit() {
      this.localUnit = +this.durationUnit
    }
  },
  created() {
    this.setDurationWithUnit(this.durationValue, this.durationUnit)
  },
  computed: {
    listOfDurationUnits() {
      let opt = {}
      // eslint-disable-next-line no-unused-vars
      for (let key in this.options) {
        if (+key !== this.localUnit) {
          opt[key] = this.options[key]
        }
      }
      return opt
    },
    title() {
      switch (this.localUnit) {
        case unitDuration.hours:
          return declension(this.localDuration, [
            `${this.$tc('unit.hours', 0)}`,
            `${this.$tc('unit.hours', 1)}`,
            `${this.$tc('unit.hours', 2)}`
          ])
        case unitDuration.minutes:
          return declension(this.localDuration, [
            `${this.$tc('unit.minutes', 0)}`,
            `${this.$tc('unit.minutes', 1)}`,
            `${this.$tc('unit.minutes', 2)}`
          ])
        default:
          return ''
      }
    },
    durationValueString() {
      if (this.localDuration === null) {
        return null
      }
      switch (this.localUnit) {
        case unitDuration.hours:
          return this.localDuration + ` ${this.$t('unit.h')}`
        case unitDuration.minutes:
          return this.localDuration + ` ${this.$tc('unit.min', 2)}`
        default:
          return ''
      }
    }
  },
  methods: {
    setDurationWithUnit(duration, unit) {
      if (typeof duration != 'number') return { value: duration }
      this.localDuration = duration
      this.localUnit = unit
    },
    changeDurationUnit(unitValue) {
      this.localUnit = parseInt(unitValue, 10)
      this.$emit('change:durationUnit', this.localUnit)
    },
    changeDurationValue(value) {
      value = typeof value == 'string' ? value.replace(',', '.') : value
      this.localDuration = value == '' ? null : +value
      this.$emit('input', this.localDuration)
    }
  }
}
</script>
